import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/compliance/client/ComplianceClient.tsx");
